import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Marketing.css'
import m1 from './../assest/images/projectss/marketing/DSC_6518.JPG'
import m2 from './../assest/images/projectss/marketing/IMG-20221227-WA0016.jpg'
import m3 from './../assest/images/projectss/marketing/IMG-20221227-WA0017.jpg'
import m4 from './../assest/images/projectss/marketing/IMG-20221227-WA0021.jpg'
import m5 from './../assest/images/projectss/marketing/IMG_20220325_104115.jpg'
import m6 from './../assest/images/projectss/marketing/IMG_20220325_133910.jpg'
export const Marketing = () => {
    const mdata=[
        {
            cover:m1
        },
        {
            cover:m2
        },
        {
            cover:m3
        },
        {
            cover:m4
        },
        {
            cover:m5
        },
        {
            cover:m6
        },
    
    ]
  return (
    <div className='market'>
        <Container>
<div className='row'>

            <div className='col-lg-6 col-md-12 col-sm-12'> 
<img src={m1}/>
            </div>  
      
            <div className='col-lg-6 col-md-12 col-sm-12'> 
<img src={m2}/>
            </div>  
</div>

<div className='row'>

            <div className='col-lg-6 col-md-12 col-sm-12'> 
<img src={m3}/>
            </div>  
      
            <div className='col-lg-6 col-md-12 col-sm-12'> 
<img src={m4}/>
            </div>  
</div>
<div className='row'>

            <div className='col-lg-6 col-md-12 col-sm-12'> 
<img src={m5}/>
            </div>  
      
            <div className='col-lg-6 col-md-12 col-sm-12'> 
<img src={m6}/>
            </div>  
</div>
        </Container>
    </div>
  )
}
